import { render, staticRenderFns } from "./FirstBItem.vue?vue&type=template&id=35a81040"
import script from "./FirstBItem.vue?vue&type=script&lang=js"
export * from "./FirstBItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports